import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const ContactInfo = () => {
  return (
    <div className="mt-8">
      <p className="text-xl font-bold mb-2 text-slate-50">
        Contact Information
      </p>
      <p className="mb-4 text-slate-50">
        If you have any questions or inquiries, feel free to reach out to us
        using the contact details below:
      </p>
      <div className="flex items-center mb-4">
        <FaEnvelope className="mr-2 text-slate-50" />
        <span className="text-slate-50">Email: sertacgltkn@gmail.com</span>
      </div>
      <div className="flex items-center">
        <FaPhoneAlt className="mr-2 text-slate-50" />
        <span className="text-slate-50">Phone: 123-456-7890</span>
      </div>
    </div>
  );
};

export default ContactInfo;
